module.exports = __webpack_public_path__ + "static/media/W5.c29366ec.jpg";